import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { SPACE_DETAIL_ACCESS_PERMISSIONS } from '&/features/settings/shared/settings-navigation';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasAnyPermission([...SPACE_DETAIL_ACCESS_PERMISSIONS])) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/spaces/pages/space-detail-page')),
});
